import './kitStyles';
/**
 * WEB-3310 юнит 2а-2 — чем человек работает сейчас: клавиатурой или пальцем и
 * мышью (эталон `window.__w2aKbd` в `touchInit`, `design/cabinet-rescin/kit.jsx`).
 * Глобального `window.*` нет (`ПЕРЕДАЧА-ФРОНТУ.md` §7) — переменная модуля:
 * ставят обработчики `TouchRules` (клавиша без ⌘/Ctrl/Alt — `true`, любое
 * `pointerdown` — `false`), читает `isKeyboardInput()` (подсказка `data-tip` по
 * фокусу — только с клавиатуры, `TipLayer`).
 * Юнит 3 (телефонный слой): признак касания `isTouchInput()` (эталон
 * `window.__w2aTouch`, `kit.jsx:900`) — `pointerdown` не мышью — да, мышью — нет,
 * ставит `TouchRules`, читает `outTap()` (`popRules.ts`); отметка смены высоты
 * клавиатуры или видимой высоты `markKeyboardChange()` (эталон `window.__kbAt`,
 * `kit.jsx:633`) — ставит `PhoneRules`, читает окно (`Modal`: 700 мс без плавной
 * высоты).
 */
let keyboard = false;
let touch = false;
let kbAt = -Infinity;

export function isKeyboardInput(): boolean {
  return keyboard;
}

export function setKeyboardInput(v: boolean): void {
  keyboard = v;
}

export function isTouchInput(): boolean {
  return touch;
}

export function setTouchInput(v: boolean): void {
  touch = v;
}

/** Высота клавиатуры или видимая высота только что сменилась. */
export function markKeyboardChange(): void {
  kbAt = performance.now();
}

/** Сколько мс прошло с последней смены (не было — `Infinity`). */
export function msSinceKeyboardChange(): number {
  return performance.now() - kbAt;
}
